/** @format */

import { inject, Injectable } from '@angular/core';
import { NonMerchAvailabilityDao } from '@pdp/data-access/dao';
import { Chain, ProductSku } from '@shared/data-access/interfaces';
import { AvailableWarrantiesBody } from '@pdp/data-access/interfaces';

@Injectable({ providedIn: 'root' })
export class NonMerchAvailabilityService {
	private readonly nonMerchAvailabilityDao = inject(NonMerchAvailabilityDao);
	private readonly chain = inject(Chain);

	getAvailableWarranties(allProductSkus: ProductSku[]) {
		const availableWarrantiesBody: AvailableWarrantiesBody = {
			location: `${this.chain.chainIdentifierAbbr}-ecomm`,
			products: allProductSkus.map((sku) => ({
				sku: sku.partNumber,
				unitSellingPrice: sku.prices.offerPrice
			}))
		};
		return this.nonMerchAvailabilityDao.getAvailableWarranties(availableWarrantiesBody);
	}
}
